import React from 'react';

type IdCellProps = {
  internalId: number;
  type?: 'delivery' | 'purchase' | 'parcel' | 'composite' | 'customs';
};

type MarkingIdCellProps = {
  internalId: number;
  type?: 'delivery' | 'purchase' | 'parcel' | 'composite' | 'customs';
  clientInternalId?: number | null;
  count?: number | null;
};

export function getPrefixByType(
  type?: 'delivery' | 'purchase' | 'parcel' | 'composite' | 'customs',
) {
  switch (type) {
    case 'composite':
      return 'T';
    case 'delivery':
      return 'D';
    case 'parcel':
      return 'K';
    case 'purchase':
      return 'V';
    case 'customs':
      return 'W';
    default:
      return 'V';
  }
}

export const IdCell: React.FC<IdCellProps> = ({ internalId, type }) => {
  return (
    <>
      {getPrefixByType(type)}
      {internalId}
    </>
  );
};

export const MarkingIdCell: React.FC<MarkingIdCellProps> = ({
  internalId,
  type,
  clientInternalId,
  count,
}) => {
  return (
    <>
      {getPrefixByType(type)}
      {internalId}-{clientInternalId}-{count}
    </>
  );
};
